goog.provide('yext.plugins.radiofy');

/**
 * Radiofy jQuery Plugin
 *
 * This plugin is used to replace native radio buttons with a custom element
 * while still responding to a label click and preserving the ability to use the
 * native element to store the value
 *
 * Usage: $('selector').radiofy();
 *
 * @author Matthew Spencer (mattjs@yext.com)
 */
(function($) {
  /**
   * RadiofyButton is an object that represents a custom radio button and
   * handles creating the element and appending it on the page at the same
   * location as the native radio button and binding interactions with both
   *
   * @param {!HTMLElement} element The native radio button element that is being customized
   * @param {!Object} options A set of options for configuring the RadiofyButton
   * @constructor
   */
  var RadiofyButton = function(element, options) {
    this.$el = $(element),
    this.$customElement = $(buttonTemplate),
    this.change = function() {},
    this.options = {};

    this.init(options);
    this.style();
    this.bindEvents();
    this.hideNativeShowCustom();
  };

  var buttonTemplate =
    '<div class="radiofy">'+
    '<div class="selected-state branded-secondary-background">'+
    +'</div></div>';

  /**
   * Default configurable options.
   */
  RadiofyButton.prototype.defaults = {
    size: '18px',
    borderWidth: '2px',
  };

  /**
   * Initialization
   */
  RadiofyButton.prototype.init = function(options) {
    this.options = $.extend(true, {}, this.defaults, options);
  };

  /**
   * Style Radio button
   */
  RadiofyButton.prototype.style = function() {
    var self = this;

    this.$customElement.css({
      width: self.options.size,
      height: self.options.size,
      borderWidth: self.options.borderWidth,
    });
  };

  /**
   * Bind events on the native and custom elements
   */
  RadiofyButton.prototype.bindEvents = function() {
    var self = this;

    this.$el.on('click.radiofy', function() {
      self.change();
    });

    this.$customElement.on('click.radiofy', function() {
      self.$el[0].checked = true;
      self.change();
      self.$el.trigger('change');
    });
  };

  /**
   * Set the button state of the custom radio element based upon the checked
   * value of the native radio element
   */
  RadiofyButton.prototype.setButtonState = function() {
    this.$customElement.toggleClass('selected', this.$el.is(':checked'));
  };

  /**
   * Hides the native radio button and shows the custom radio button
   */
  RadiofyButton.prototype.hideNativeShowCustom = function() {
    this.$el.hide();
    this.$customElement.hide().insertBefore(this.$el).fadeIn(150);
  };

  /**
   * Radiofy sets a general update function for its RadiofyButtons so that
   * all buttons in the set will have setButtonState triggered when any one of
   * them changes. This is needed because even though the native radio button is
   * set correctly the custom button needs to be updated when it becomes 'deselected'
   */
  RadiofyButton.prototype.setChange = function(fn) {
    this.change = fn;
  };

  /**
   * Radiofy is a container for related RadiofyButton objects
   *
   * When a radio button is 'deselected' there is no native event triggered by the browser
   * so this manages triggering a 'change' method that will set the correct button state
   * for all of the custom elements
   *
   * @constructor
   * @param {!jQuery} $radioElements List of radio button elements as a jquery object
   * @param {!Object} options A set of options for the to be passed to the RadiofyButton class
   */
  var Radiofy = function($radioElements, options) {
    var self = this;
    this.radiofyButtons = [];

    $radioElements.each(function() {
      self.instantiateButton(this, options);
    });
  };

  /**
   * Instantiates a RadioButton class for a particular radio input element and
   * calls the set change method which attach a Radiofy method to the RadiofyButton
   */
  Radiofy.prototype.instantiateButton = function(element, options) {
    var self = this;
    var button = new RadiofyButton(element, options);

    button.setChange(function() {
      self.change();
    });
    this.radiofyButtons.push(button);
  };

  /**
   * Loops through all of the RadiofyButtons in the set and calls the setButtonState
   * method which will sync the custom element state with its native counterpart
   */
  Radiofy.prototype.change = function() {
    $.each(this.radiofyButtons, function(index, value) {
      value.setButtonState();
    });
  };

  /**
   * jQuery Constructor
   */
  $.fn.radiofy = function(options) {
    new Radiofy(this, options);
  };
})(jQuery);
